var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bg",attrs:{"id":"bg"}},[_c('img',{attrs:{"src":"posters/soon-04.jpg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }